// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  root: {
    display: "flex",
    flex: 1,
    overflow: "hidden"
  }
}), { index: 1 })